<div [ngClass]="['modal', 'dialog', show ? 'show' : 'hide']">
    <div class="modalTile erweiterte-suche__container">

        <!-- Schliessen Button -->
        <div class="closeMe" (click)="close()" title="{{ txtClose }}"></div>

        <!-- Ueberschrift -->
        <div class="erweiterte-suche__headline">
            Erweiterte Suche
        </div>

        <div class="erweiterte-suche__search">
            <label for="auftraggebersuche"
                   class="field-label"
                   style="white-space: nowrap;">Auftraggebersuche:&nbsp;*</label>
            <input type="text"
                   id="auftraggebersuche"
                   style="margin-left: 0.5rem; margin-right: 1rem; max-width: 300px"
                   [class.error]="auftraggeberSucheError && !auftraggeberSucheQuery"
                   [(ngModel)]="auftraggeberSucheQuery"
                   (keyup)="onInputFieldKeyUp($event)">

            <label for="plzsuche"
                   class="field-label"
                   style="white-space: nowrap;">Suche nach PLZ:</label>
            <input type="text"
                   id="plzsuche"
                   maxlength="5"
                   style="margin-left: 0.5rem; margin-right: 1rem; max-width: 100px"
                   [(ngModel)]="plzSucheQuery"
                   (keyup)="onInputFieldKeyUp($event)">

            <elem-button buttonRole="PRIMARY"
                         icon="icon-search-big"
                         style="padding: 0 0.5rem; margin-left: auto"
                         (click)="onSucheBtnClick()">Suchen</elem-button>

        </div>

        <div class="erweiterte-suche__result">
            @if (isLoading) {
                <p class="message-str message-headline">Lade Suchergebnisse...</p>
            } @else {
                @if (messageHeadline) {
                    <p class="message-str message-headline">{{ messageHeadline }}</p>
                    @if (messageContent) {
                        <p class="message-str">{{ messageContent }}</p>
                    }
                } @else {
                    <elem-new-table [tableHeaders]="auftraggeberTableHeaders"
                                    [tableData]="auftraggeberTableData"
                                    (rowSelected)="onRowSelected($event)"></elem-new-table>
                }
            }
        </div>

        <div class="erweiterte-suche__footer">
            <elem-button buttonRole="TERTIARY" (click)="onCancelClick()">Auftraggeber manuell erfassen</elem-button>

            <elem-button buttonRole="PRIMARY"
                         [disabled]="!selectedAuftraggeber"
                         [title]="!selectedAuftraggeber ? 'Bitte wählen Sie einen Auftraggeber aus, um ihn zu übernehmen.' : ''"
                         (click)="onApplyClick()">Übernehmen
            </elem-button>
        </div>

    </div>
</div>
